class DrawerQuickBuy extends window.BAO.CustomElement() {
  _loading = false

  constructor () {
    super()

    this.sectionId = 'quick-buy'
    this.handleTrigger = this.handleTrigger.bind(this)
    this.renderDrawerContent = this.renderDrawerContent.bind(this)
    this.updateBodyContent = this.updateBodyContent.bind(this)

    this.giftWrapSectionId = 'quick-buy-gift-wrap'
    this.handleGiftWrapTrigger = this.handleGiftWrapTrigger.bind(this)
    this.renderGiftWrapDrawerContent =
      this.renderGiftWrapDrawerContent.bind(this)
    this.updateGiftWrapContent = this.updateGiftWrapContent.bind(this)
  }

  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(document.body, 'click', this.handleTrigger)
  }

  handleTrigger (event) {
    const triggerEl = event.target.closest(
      '[data-drawer-quick-buy-external-el="trigger"]',
    )

    if (!triggerEl) return

    const productUrl = triggerEl?.dataset.productUrl
    if (!productUrl) return

    this.renderDrawerContent(productUrl)
  }

  async handleGiftWrapTrigger (event) {
    const triggerEl = event.target.closest(
      '[data-drawer-quick-buy-external-el="giftWrapTrigger"]',
    )

    if (!triggerEl) return

    const productUrlEl =
      triggerEl.querySelector('[data-product-url]') || triggerEl
    const productUrl = productUrlEl?.dataset?.productUrl

    if (!productUrl) return

    await this.renderGiftWrapDrawerContent(productUrl)
  }

  async renderDrawerContent (productUrl) {
    this.loading = true

    try {
      const html = await this.sectionRenderer.fetchSingle(
        this.sectionId,
        productUrl,
      )
      const innerHtml = this.sectionRenderer.getInnerHtml(html)

      if (!html || !innerHtml) {
        console.error('Quick buy: Failed to load product content')
        return
      }

      this.updateBodyContent(innerHtml)
    } catch (error) {
      console.error('Quick buy: Error loading product', error)
    } finally {
      setTimeout(() => {
        this.loading = false
      }, 500)
    }

    this.externalEls?.giftWrapTrigger?.elements.forEach((triggerEl) => {
      this.listeners.add(triggerEl, 'click', this.handleGiftWrapTrigger)
    })
  }

  async renderGiftWrapDrawerContent (productUrl) {
    this.loading = true

    try {
      const html = await this.sectionRenderer.fetchSingle(
        this.giftWrapSectionId,
        productUrl,
      )
      const innerHtml = this.sectionRenderer.getInnerHtml(html)

      if (!html || !innerHtml) {
        console.error('Quick buy: Failed to load gift wrap content')
        return
      }

      this.updateGiftWrapContent(innerHtml)
    } catch (error) {
      console.error('Quick buy: Error loading gift wrap', error)
    } finally {
      this.loading = false
    }
  }

  updateGiftWrapContent (content) {
    this.externalEls.giftWrapBody.element.innerHTML = ''
    this.externalEls.giftWrapBody.element.insertAdjacentHTML(
      'beforeend',
      content,
    )
  }

  updateBodyContent (content) {
    const bodyEl = this.els.body.element
    if (!bodyEl) return

    this.checkPreviousHoopDrawer(bodyEl)

    bodyEl.innerHTML = ''
    bodyEl.insertAdjacentHTML('beforeend', content)
  }

  checkPreviousHoopDrawer (bodyEl) {
    const hoopDrawerTriggerEl = bodyEl.querySelector(this.hoopDrawerSelector)
    if (!hoopDrawerTriggerEl) return

    const drawerKey = hoopDrawerTriggerEl.dataset.drawersTrigger
    if (!drawerKey) return

    const drawerEl = document.querySelector(`site-drawer[key="${drawerKey}"]`)

    if (drawerEl) drawerEl.remove()
  }

  /**
   * @returns {sectionRenderer} The BAO sectionRenderer class
   */
  get sectionRenderer () {
    return window.BAO.sectionRenderer
  }

  get loadingClass () {
    return this.getAttribute('loading-class') || 'drw-Drawer-loading'
  }

  get hoopDrawerSelector () {
    return `[data-drawer-quickbuy-el="hoop-trigger"]`
  }

  get loading () {
    return this._loading
  }

  set loading (val) {
    this._loading = val
    this.classList.toggle(this.loadingClass, val)
  }
}

if (!customElements.get('drawer-quick-buy')) {
  customElements.define('drawer-quick-buy', DrawerQuickBuy)
}
